'use client';

import { type JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { RecaptchaV2Checkbox } from './RecaptchaV2Checkbox';

export interface RecaptchaV2ChallengeProps {
    onChange: (token: string | null) => void;
    // Optional layout override; base flex/centering classes are always applied and merged.
    className?: string;
}

/**
 * The v2 checkbox plus a short helper line, shown when a flow escalates from invisible v3. To get
 * a fresh checkbox after a failed attempt, remount it with a `key` at the call site (e.g.
 * `<RecaptchaV2Challenge key={resetKey} … />`) rather than threading a reset value through props.
 */
export function RecaptchaV2Challenge({ onChange, className }: RecaptchaV2ChallengeProps): JSX.Element {
    return (
        <div className={twMerge('flex flex-col items-center gap-2', className)}>
            <p className="w-full rounded-md border border-blue-200 bg-blue-50 px-3 py-2 text-center text-sm font-semibold text-blue-800">
                Please confirm you&apos;re not a robot.
            </p>
            <RecaptchaV2Checkbox onChange={onChange} />
        </div>
    );
}
